<template>
  <div class="item">
    <div class="slot_top_img">
      <slot name="top"><img src="~@/assets/image/标题1.png" alt="" /></slot>
    </div>
    <div class="contentWamp">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
    export default {
      name:"ContentWamp"
    };
</script>

<style lang="less">
  .item {
    padding: 0.625rem;
    width: 100%;
    height: 100%;
    .contentWamp {
      width: 100%;
      height: 85%;
      position: relative;
      box-sizing: border-box;
      background: url("~@/assets/image/线框4.png") no-repeat;
      background-size: 100% 100%;
      padding: 0 0.625rem ;
    }
    .slot_top_img {
      width: 16.4375rem;
      height: 3.0625rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
</style>